import { Module, VuexModule, Mutation, Action, getModule } from 'vuex-module-decorators';
import store from '@/store/index';
import ApiHoursDiary from '@/api/ApiHoursDiary';
import {
  GetHoursDiarySearchRequest,
  GetHoursDiaryRequest,
  PostHoursDiaryRequest,
  ChangeHoursDiaryRequest,
  ApproveHoursDiaryRequest
} from '@/model/Request';
import { NurseryHoursDiaryDetailResponse, MessageOkResponse } from 'chaild-api/lib';

export interface HoursDiaryState {
  diaries: NurseryHoursDiaryDetailResponse[];
  diaryDetail: NurseryHoursDiaryDetailResponse | null;
}

@Module({ dynamic: true, store, name: 'hoursDiary', namespaced: true })
export class HoursDiaryModule extends VuexModule implements HoursDiaryState {
  public diaries: NurseryHoursDiaryDetailResponse[] = [];
  public diaryDetail: NurseryHoursDiaryDetailResponse | null = null;

  @Action({ rawError: true })
  public async searchHoursDiary(input: GetHoursDiarySearchRequest) {
    const res = await ApiHoursDiary.searchHoursDiary(input);
    this.SET_DIARIES(res);
    return res;
  }

  @Mutation
  private SET_DIARIES(items: NurseryHoursDiaryDetailResponse[]) {
    this.diaries = items;
  }

  @Action({ rawError: true })
  public async getHoursDiary(input: GetHoursDiaryRequest) {
    const res = await ApiHoursDiary.getHoursDiary(input);
    this.SET_DIARY_DETAIL(res);
    return res;
  }

  @Mutation
  private SET_DIARY_DETAIL(item: NurseryHoursDiaryDetailResponse) {
    this.diaryDetail = item;
  }

  @Action({ rawError: true })
  public async postHoursDiary(input: PostHoursDiaryRequest) {
    return ApiHoursDiary.postHoursDiary(input);
  }

  @Action({ rawError: true })
  public async updateHoursDiary(input: ChangeHoursDiaryRequest) {
    return ApiHoursDiary.putHoursDiary(input);
  }

  @Action({ rawError: true })
  public async deleteHoursDiary(input: ChangeHoursDiaryRequest) {
    return ApiHoursDiary.deleteHoursDiary(input);
  }

  @Action({ rawError: true })
  public async approveHoursDiary(input: ApproveHoursDiaryRequest) {
    return ApiHoursDiary.approveHoursDiary(input);
  }
}

export const hoursDiaryModule = getModule(HoursDiaryModule);
